module.exports = __webpack_public_path__ + "static/media/dashboard-logo.7969d4d4.png";